export default __webpack_public_path__ + "static/media/teams.7d4f3481.svg";